import { render, staticRenderFns } from "./SupplierNtaxCode.vue?vue&type=template&id=36255cb2&"
import script from "./SupplierNtaxCode.vue?vue&type=script&lang=js&"
export * from "./SupplierNtaxCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports